import { Box, Flex, Link, Text } from '@workwhile/ui'
import { ShiftRowSchema } from 'pages/Shifts/BulkCreateShifts/bulkCreateShiftsSchema'
import { useBulkCreateShiftsContextValue } from 'pages/Shifts/BulkCreateShifts/context/BulkCreateShiftsProvider'
import React from 'react'
import styles from './DoneTable.module.css'
import { useCompanyDetailsByIdQuery } from 'queries/company'
import { differenceInMinutes, format } from 'date-fns'
import { getLongDuration } from 'lib/time'

const DoneRow = ({
  shift,
  index,
}: {
  shift: ShiftRowSchema
  index: number
}) => {
  const {
    state: { companies, createShiftsState },
  } = useBulkCreateShiftsContextValue()
  const { data: companyDetail } = useCompanyDetailsByIdQuery(shift.companyId)

  const company = companies.find((company) => company.id === shift.companyId)
  const position = companyDetail?.positions?.find(
    (position) => position.id === shift.positionId
  )

  const formattedShiftStartDateTime = format(
    shift.shiftStartDate,
    'MMM dd, yyyy h:mma'
  )

  const formattedShiftEndDateTime = format(
    shift.shiftEndDate,
    'MMM dd, yyyy h:mma'
  )

  const shiftDuration = differenceInMinutes(
    shift.shiftEndDate,
    shift.shiftStartDate
  )
  const formattedShiftDuration = getLongDuration(shiftDuration)

  const createShiftResult = createShiftsState.result?.shifts?.[shift.rowId]

  return (
    <tr>
      <td align="center">{index + 1}</td>
      <td>{company?.name ?? shift.companyId}</td>
      <td>{shift.locationName}</td>
      <td>{position?.name ?? shift.positionId}</td>
      <td>{formattedShiftStartDateTime}</td>
      <td>
        {formattedShiftEndDateTime} ({formattedShiftDuration})
      </td>
      <td>{shift.shiftWorkersNeeded}</td>
      <td>
        <Link to={`/shifts/${createShiftResult?.shiftId}`} target="_blank">
          View Shift
        </Link>
      </td>
    </tr>
  )
}

export const DoneTable = () => {
  const {
    state: { formState },
  } = useBulkCreateShiftsContextValue()

  return (
    <Flex
      flexDirection="column"
      gap={3}
      align="center"
      justifyContent="flex-start"
      height="100%"
      minHeight="auto"
    >
      <Box width="100%" overflow="auto" pb={3}>
        <table className={styles.shiftsTable}>
          <thead>
            <tr>
              <th align="center" className={styles.rowNumberColumn}>
                #
              </th>
              <th align="center">
                <Text>Company</Text>
              </th>
              <th align="center">
                <Text>Location Name</Text>
              </th>
              <th align="center">
                <Text>Position</Text>
              </th>
              <th align="center">
                <Text>Starts At</Text>
              </th>
              <th align="center">
                <Text>Ends At</Text>
              </th>
              <th align="center">
                <Text>Workers Needed</Text>
              </th>
              <th align="center">
                <Text></Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {formState?.shifts?.map((shift, index) => (
              <DoneRow
                key={`shift-${shift.rowId}`}
                index={index}
                shift={shift}
              />
            ))}
          </tbody>
        </table>
      </Box>
    </Flex>
  )
}
